export default "<p>bandwidth-report-filter works!</p>\r\n";